module.exports = __webpack_public_path__ + "static/media/logo_dark.df291b56.png";